import React from 'react';

export default class Example extends React.Component {
  render() {
    return (
      <div style={{ padding: '24px' }}>
        <p>As you scroll, examples will show here.</p>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/sections/00-Start/App.js